// assistant-voix.js — Assistant NRJSOLAIRE avec audio, multilingue (⚠️ API exposée temporairement)

const assistantId = "asst_UXO1CRYJSaFUHHhiW7UAwKuF";
const endpoint = "https://api.openai.com/v1";
const apiKey = "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";
let threadId = null;

async function sendMessage() {
  const input = document.getElementById("user-input");
  const message = input?.value.trim();
  if (!message) return;

  appendMessage("user", message);
  input.value = "";
  toggleInput(false);

  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${apiKey}`
  };

  try {
    if (!threadId) {
      const threadRes = await fetch(`${endpoint}/threads`, { method: "POST", headers });
      const threadData = await threadRes.json();
      threadId = threadData.id;
    }

    await fetch(`${endpoint}/threads/${threadId}/messages`, {
      method: "POST",
      headers,
      body: JSON.stringify({ role: "user", content: message })
    });

    const runRes = await fetch(`${endpoint}/threads/${threadId}/runs`, {
      method: "POST",
      headers,
      body: JSON.stringify({ assistant_id: assistantId })
    });

    const runData = await runRes.json();
    const runId = runData.id;

    let status = "";
    while (status !== "completed") {
      const check = await fetch(`${endpoint}/threads/${threadId}/runs/${runId}`, { headers });
      const checkData = await check.json();
      status = checkData.status;
      await new Promise(r => setTimeout(r, 1000));
    }

    const messagesRes = await fetch(`${endpoint}/threads/${threadId}/messages`, { headers });
    const messagesData = await messagesRes.json();
    const last = messagesData.data.find(m => m.role === "assistant");
    const text = last?.content?.[0]?.text?.value || "⚠️ Réponse vide ou invalide.";

    appendMessage("assistant", text);
    speak(text);
  } catch (err) {
    console.error("Erreur assistant:", err);
    appendMessage("assistant", "❌ Une erreur est survenue. Veuillez réessayer.");
  } finally {
    toggleInput(true);
  }
}

function appendMessage(role, text) {
  const container = document.getElementById("messages");
  const div = document.createElement("div");
  div.style.margin = "8px 0";
  div.style.padding = "8px";
  div.style.borderRadius = "6px";
  div.style.background = role === "user" ? "#e0f7e9" : "#f1f1f1";
  div.innerText = text;
  container.appendChild(div);
  container.scrollTop = container.scrollHeight;
}

function toggleInput(state) {
  const input = document.getElementById("user-input");
  const button = document.querySelector("#chatbox button[onclick='sendMessage()']");
  if (input) input.disabled = !state;
  if (button) button.disabled = !state;
}

function startListening() {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) {
    alert("Navigateur non compatible avec la reconnaissance vocale.");
    return;
  }
  const recognition = new SpeechRecognition();
  recognition.lang = detectInputLang();
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;
  recognition.onresult = (event) => {
    const text = event.results[0][0].transcript;
    document.getElementById("user-input").value = text;
    sendMessage();
  };
  recognition.onerror = (event) => {
    console.warn("Erreur vocale:", event.error);
    alert("Erreur reconnaissance vocale : " + event.error);
  };
  recognition.start();
}

function speak(text) {
  if (!window.speechSynthesis) return;
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = detectLang(text);
  utterance.rate = 1;
  utterance.pitch = 1;
  speechSynthesis.speak(utterance);
}

function detectLang(text) {
  if (/(the|you|and|can|your|hello)/i.test(text)) return "en-US";
  if (/(le|la|nous|tu|bonjour)/i.test(text)) return "fr-FR";
  if (/(def|rek|na|ndiaye|ña)/i.test(text)) return "wo-SN";
  return navigator.language || "fr-FR";
}

function detectInputLang() {
  const userLang = navigator.language || navigator.userLanguage;
  return userLang.startsWith("fr") ? "fr-FR" : userLang.startsWith("en") ? "en-US" : "fr-FR";
}

function toggleChat() {
  const chatbox = document.getElementById("chatbox");
  if (!chatbox) return;
  chatbox.style.display = chatbox.style.display === "none" ? "flex" : "none";
}
